const JULY_MONTH_INDEX = 6;
const PROMO_END_DAY = 1;
const PROMO_END_YEAR = 2026;

export const FILE_TRANSFER_PROMO_TEXT =
  "Paste here. Pick up anywhere.";
export const FILE_TRANSFER_PROMO_STORAGE_KEY =
  "netpad:file-transfer-promo:v2";
export const FILE_TRANSFER_PROMO_STORAGE_VALUE = "shown";
export const FILE_TRANSFER_PROMO_END_AT = new Date(
  PROMO_END_YEAR,
  JULY_MONTH_INDEX,
  PROMO_END_DAY
).getTime();
export const FILE_TRANSFER_PROMO_HOLD_MS = 4200;
export const FILE_TRANSFER_PROMO_SERVING_MS = 700;
export const FILE_TRANSFER_PROMO_LANDING_MS = 1700;
export const FILE_TRANSFER_PROMO_CAPTION_MS = 400;
export const FILE_TRANSFER_PROMO_DESKTOP_QUERY =
  "(min-width: 768px) and (pointer: fine)";
export const FILE_TRANSFER_PROMO_PHASES = {
  CAPTION: "caption",
  HIDDEN: "hidden",
  HOLDING: "holding",
  LANDING: "landing",
  SERVING: "serving",
};
